export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const GOOGLE_ACCOUNT_AUTH = 'GOOGLE_ACCOUNT_AUTH';
export const GET_CSRF_TOKEN = 'GET_CSRF_TOKEN';
export const AUTH_GET_PERMISSION = 'AUTH_GET_PERMISSION';



// WEBPACK FOOTER //
// ./src/auth/types.js